import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import * as API from "../../libs/service";

import Popup01 from "../popup/Popup01"

export default function PopupPlusAdmin(props) {
    const { 
        title,
        subTitle,
        text, 
        lefttext,
        width, 
        button, 
        buttonCancel, 
        func, 
        setFunc, 
        noneLoading, 
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        max_width,
        admin_set
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [maxWidthCut, setMaxWidthCut] = useState(max_width);

    const [idTitleView, setIdTitleView] = useState(false);
    const [idValue, setIdValue] = useState('');
    const [idAster, setIdAster] = useState(true);
    const [idErr, setIdErr] = useState(0);
    const [idXbtn, setIdXbtn] = useState(false);
    const [idSearch, setIdsearch] = useState(false);

    const [nameTitleView, setNameTitleView] = useState(false);
    const [nameValue, setNameValue] = useState('');
    const [nameAster, setNameAster] = useState(true);
    const [nameErr, setNameErr] = useState(0);
   
    const [licenseStatus, setLicenseStatus] = useState(1);

    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    const setFunction = () => {
        if(setFunc) setFunc();
        dispatch(close());
    };


    const InputChange = (event) => {
        const { name, value } = event.target;

        if(name === "login_id") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setIdValue(value)

            if(value) {
                setIdAster(false);
                setIdTitleView(true)
                setIdXbtn(true)
                setIdsearch(true)
            } else {
                setIdAster(true);
                setIdTitleView(false)
                setIdXbtn(false)
                setIdsearch(false)
            }

            if(!EmailChk.test(value)) {
                setIdErr(2);
                return;
            } else {
                setIdErr(0);
            }
        }

        if(name === "name") {
            setNameValue(value)

            if(value) {
                let NameChk = /^[가-힣a-zA-Z]*$/;
                setNameAster(false);
                setNameTitleView(true)

                if(!NameChk.test(value)) {
                    setNameErr(1);
                    return;
                } else {
                    setNameErr(0);
                }
            } else {
                setNameAster(true);
                setNameTitleView(false)
            }
        }

    }

    const handleChange = (e) => {
        setLicenseStatus(Number(e.target.value));
    };

    return (
        <>
            <div 
                className={"popup_default01"} 
                style={{ 
                    maxWidth: max_width ? maxWidthCut : '400px', 
                    width: '100%', 
                    marginLeft: 10, 
                    marginRight: 10,
                }}
                >
                {x_btn &&
                    <div 
                        className="popup_x_btn_box"
                        style={{
                            
                        }}
                    >
                        <img src={require("../../assets/images/exit-icon.svg").default} 
                            className="popup_x_btn" 
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                        <div style={{ height: 16 }} />
                    </div>
                }
                <div 
                    className={`popup_content_box profile`}
                    style={{

                    }}
                >

                    <div className="title_box">
                        <p>{lang === 0 ? '관리자 등록' : 'Admin registration'}</p>
                        <span>{lang === 0 ? '추가하실 관리자를 검색하세요' : 'Search for the administrator you want to add.'}</span>
                    </div>

                    <div className="input_box">
                        <div 
                            className="input_div pw_div"
                            style={{
                                border: nameTitleView ? '1px solid #0E6AF4' : ''
                            }}
                        >
                            {idTitleView &&
                                <div className="input_focus pw_focus">
                                    <p>{lang === 0 ? '이메일' : 'Email'}</p>
                                    <span 
                                        className="input_aster"
                                        style={{
                                            left: '32px',
                                            top: '-2px'
                                        }}
                                    >
                                        *
                                    </span>
                                </div>
                            }
                            <input 
                                type="text"
                                placeholder={lang === 0 ? '이메일 검색' : 'Search by email'}
                                className="input_pw"
                                name="login_id"
                                value={idValue}
                                onChange={InputChange}
                                onBlur={() => {
                                    setIdTitleView(false)
                                }}
                            />
                            {idAster && 
                                <>
                                    <span 
                                        className="input_aster"
                                        style={{
                                            left: '94px',
                                            top: idTitleView ? '20px' : '15px'
                                        }}
                                    >
                                        *
                                    </span>
                                </>
                            }

                            {idSearch &&
                                <img 
                                    src={require("../../assets/icon/search_black.svg").default} 
                                    className="input_x search"
                                    onClick={() => {

                                    }}
                                />
                            }

                            {idXbtn &&
                                <img 
                                    src={require("../../assets/icon/x-circle.svg").default} 
                                    className="input_x"
                                    onClick={() => {
                                        setIdValue('')
                                        setIdXbtn(false)
                                        setIdAster(true)
                                        setIdsearch(false)
                                    }}
                                />
                            }
                        </div>
                        {idErr == 2 && <span className="err_msg id">{lang === 0 ? '가입된 회원이 아닙니다.' : 'The user is not a registered member.'}</span>}
                    </div>          

                    <div className="email_search_box">
                        <p>aiefaf@naver.com (알렉스)</p>
                        <span>{lang === 0 ? '등록된 관리자는 해당 Plan의 멤버 추가 및 관리하실 수 있습니다.' : 'Registered administrators can add and manage members for the selected plan.'}</span>
                    </div>
                    

                    {(buttonCancel || button || longButton) &&
                        <div 
                            className="popup_btn_box"
                            style={{ width: '100%' }}
                        >

                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if(cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    className="button_success"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            dispatch(close());
                                        } else {
                                            setFunction();
                                        }
                                    }}
                                >
                                    {button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {
                                        
                                    }}
                                >
                                    {longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
